import React, { Suspense } from 'react'
import { Route, Routes } from 'react-router'
import { ROUTES } from '@constants/index'
import { useEnvironment } from '@hooks/useEnvironment'
import Error from '@pages/Error/Error'
import { LoginRedirect } from './LoginRedirect'
import { StartRedirect } from './StartRedirect'
import { ResumeRedirect } from './ResumeRedirect'
import { FallbackIndicator } from './FallbackIndicator/FallbackIndicator'

const Introduction = React.lazy(() => import('@pages/Introduction/Introduction'))
const EligibleInsurers = React.lazy(() => import('@pages/EligibleInsurers/EligibleInsurers'))
const InsuranceInformationForm = React.lazy(() => import('@pages/InsuranceInformationForm/InsuranceInformationForm'))
const Quote = React.lazy(() => import('@pages/Quote/Quote'))
const SelectPrescription = React.lazy(() => import('@pages/SelectPrescription/SelectPrescription'))
const ValidatePrescription = React.lazy(() => import('@pages/ValidatePrescription/ValidatePrescription'))
const SelectProducts = React.lazy(() => import('@pages/SelectProducts/SelectProducts'))
const ReviewClaim = React.lazy(() => import('@pages/ReviewClaim/ReviewClaim'))
const InsuranceMember = React.lazy(() => import('@pages/InsuranceMember/InsuranceMember'))
const Loading = React.lazy(() => import('@pages/Loading/Loading'))
const ChangeInsuredProduct = React.lazy(
  () => import('@pages/InsuranceMember/components/ChangeInsuredProduct/ChangeInsuredProduct')
)
const DistributeBenefits = React.lazy(
  () => import('@pages/InsuranceMember/components/DistributeBenefits/DistributeBenefits')
)

export const AppRoutes: React.FC = () => {
  const { basePath } = useEnvironment()
  const dbpath = basePath.endsWith('/') ? ROUTES.BASE_NO_SLASH : ROUTES.BASE

  return (
    <Suspense fallback={<FallbackIndicator />}>
      <Routes>
        <Route path={`${basePath}${dbpath}`}>
          <Route index element={<Introduction />} />
          <Route path={ROUTES.LOGIN_REDIRECT} element={<LoginRedirect />} />
          <Route path={ROUTES.START} element={<StartRedirect />} />
          <Route path={ROUTES.RESUME} element={<ResumeRedirect />} />
          <Route path={ROUTES.INSURANCE_INFORMATION} element={<InsuranceInformationForm />} />
          <Route path={ROUTES.QUOTE} element={<Quote />} />
          <Route path={ROUTES.ELIGIBLE_INSURERS} element={<EligibleInsurers />} />
          <Route path={ROUTES.SELECT_PRESCRIPTION} element={<SelectPrescription />} />
          <Route path={ROUTES.VALIDATE_PRESCRIPTION} element={<ValidatePrescription />} />
          <Route path={ROUTES.SELECT_PRODUCT} element={<SelectProducts />} />
          <Route path={ROUTES.CHANGE_INSURED_PRODUCT} element={<ChangeInsuredProduct />} />
          <Route path={ROUTES.REVIEW_CLAIM} element={<ReviewClaim />} />
          <Route path={ROUTES.INSURANCE_MEMBER} element={<InsuranceMember />} />
          <Route path={ROUTES.DISTRIBUTE_BENEFITS} element={<DistributeBenefits />} />
          <Route path={ROUTES.ERROR} element={<Error />} />
          <Route path={ROUTES.LOADING} element={<Loading />} />
        </Route>
      </Routes>
    </Suspense>
  )
}
